var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E5FFEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 13.3334V32L17.0667 27.2C17.5278 26.8529 18.0896 26.6656 18.6667 26.6667H29.3334C30.8062 26.6667 32.0001 25.4728 32.0001 24V13.3334C32.0001 11.8606 30.8062 10.6667 29.3334 10.6667H13.3334C11.8607 10.6667 10.6667 11.8606 10.6667 13.3334ZM13.3334 26.6667V13.3334H29.3334V24H17.7787C17.2015 23.9985 16.6396 24.1858 16.1787 24.5334L13.3334 26.6667Z",
    fill: "#32C050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3334 37.3334V20C37.3334 18.5273 36.1395 17.3334 34.6667 17.3334V32L31.8214 29.8667C31.3606 29.5191 30.7987 29.3318 30.2214 29.3334H17.3334C17.3334 30.8061 18.5273 32 20.0001 32H29.3334C29.9106 31.999 30.4723 32.1862 30.9334 32.5334L37.3334 37.3334Z",
    fill: "#32C050"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.d202ce06.svg";
export { ForwardRef as ReactComponent };